<template>
  <div>
    <b-row class="report-dashboard-header mx-0" align-v="center">
      <b-col cols="12" md="4">
        <div class="font-weight-bold" v-text="$lang.project_title" />
        <small
          class="text-white font-font-weight-light m-0"
          v-text="$lang.project_description"
        />
      </b-col>
      <b-col cols="12" md="4" class="text-center">
        <b-img
          class="navbar-brand-full"
          :src="$config.images.tinyLogo"
          alt="Logo"
          width="40"
        />
      </b-col>
      <b-col
        cols="12"
        md="4"
        class="text-right text-white d-flex align-self-center justify-content-end"
      >
        <span class="cursor_pointer" @click="openParvandehListModal">
          انتخاب پرونده
        </span>
        <router-link tag="div" to="/" class="ml-4 cursor_pointer">
          صفحه اصلی
        </router-link>
      </b-col>
    </b-row>
    <b-modal size="xl" v-model="parvandehListModal" hide-footer hide-header>
      <LocalStorageList
        v-if="modalState === 'LOCAL-STORAGE-LIST'"
        @showParvandehList="showParvandehList"
      />
      <ParvandehList v-if="modalState === 'PARVANDEH-LIST'" />
    </b-modal>
  </div>
</template>

<script>
import LocalStorageList from "./LocalStorageList.vue";
import ParvandehList from "./ParvandehList.vue";
import useServices from "./dependencies/useServices";
import { inject, provide, ref, toRefs, watch } from "vue";

export default {
  components: { LocalStorageList, ParvandehList },
  props: {
    activeTab: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    // generate props data
    const { activeTab } = toRefs(props);

    // open and close parvandeh modal
    const parvandehListModal = ref(false);
    const openParvandehListModal = () => {
      parvandehListModal.value = true;
      showLocalStorageList();
    };
    const closeParvandehListModal = () => (parvandehListModal.value = false);

    // generate modal content
    const modalState = ref("LOCAL-STORAGE-LIST");
    const showLocalStorageList = () =>
      (modalState.value = "LOCAL-STORAGE-LIST");
    const showParvandehList = () => (modalState.value = "PARVANDEH-LIST");

    provide("close", closeParvandehListModal);

    const updateCloseParvandehModel = inject("updateCloseParvandehModel");
    watch(parvandehListModal, (value) => updateCloseParvandehModel(value));

    // get services of external file and run when watched active tab
    const { getData } = useServices([]);
    watch(activeTab, (value) => getData(value, false));

    // return data to be used in template
    return {
      parvandehListModal,
      openParvandehListModal,
      closeParvandehListModal,
      modalState,
      showLocalStorageList,
      showParvandehList,
      activeTab,
    };
  },
};
</script>
<style lang="scss" scoped>
.report-dashboard-header {
  background-color: #161616;
  color: #626a69;
  height: 60px;
}
</style>
